export const resolveSurveyType = (survey) => {
  if (!survey) return "StandardSurvey";
  if (survey.companyId) return "CustomSurvey";
  if (survey.systemManaged !== undefined) return "StandardSurvey";
  return "StandardSurvey";
};

export const chunkSurveyQuestions = (questions = [], chunkSize = 5) => {
  const grouped = {};
  questions.forEach((question) => {
    const key = question.category || "common";
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(question);
  });

  const orderedCategories = Object.keys(grouped);
  const chunks = [];
  orderedCategories.forEach((category) => {
    const items = grouped[category];
    for (let index = 0; index < items.length; index += chunkSize) {
      chunks.push({
        category,
        questions: items.slice(index, index + chunkSize),
      });
    }
  });
  return chunks;
};

export const calculateMaxScore = (questions = []) => {
  return questions.reduce((total, question) => {
    if (!Array.isArray(question.options) || question.options.length === 0) {
      return total;
    }
    const maxOptionPoints = Math.max(
      ...question.options.map((opt) => Number(opt.points) || 0),
    );
    return total + maxOptionPoints;
  }, 0);
};

export const countAnsweredQuestions = (responses = {}) => {
  return Object.keys(responses).filter((key) => {
    const value = responses[key];
    if (value === undefined || value === null) return false;
    if (Array.isArray(value)) return value.length > 0;
    return value !== "";
  }).length;
};
